import initialState from '../initialState.js';
import {
    GET_CLAIMS_SUCCESS,
    GET_CLAIM_SUCCESS,
    SET_CLAIM_TYPES,
    ADD_MEMBER_NOTE,
    UPDATE_CLAIM,
    GET_PREDETERMINATIONS_SUCCESS,
    REMOVE_PREDETERMINATION
} from '../../actions/types/adjudication';

export default (state = initialState.adjudication, action) => {
    switch (action.type) {
        case GET_CLAIM_SUCCESS: {
            return {
                ...state,
                currentClaim: action.currentClaim
            };
        }

        case SET_CLAIM_TYPES: {
            return {
                ...state,
                claimTypes: action.claimTypes
            };
        }

        case GET_CLAIMS_SUCCESS: {
            const claims = state.claimsList ? [ ...state.claimsList ] : [];

            return {
                ...state,
                claimsList: action.shouldAppend ? [ ...claims, ...action.claims ] : [ ...action.claims ],
                cursor: action.cursor
            };
        }

        case GET_PREDETERMINATIONS_SUCCESS: {
            const predeterminations = state.predeterminations ? [ ...state.predeterminations ] : [];

            return {
                ...state,
                predeterminations: action.shouldAppend ? [ ...predeterminations, ...action.predeterminations ] : [ ...action.predeterminations ],
                predeterminationsCursor: action.predeterminationsCursor
            };
        }

        case ADD_MEMBER_NOTE: {
            return {
                ...state,
                currentClaim: {
                    ...state.currentClaim,
                    memberNotes: [ action.data, ...state.currentClaim.memberNotes ]
                }
            };
        }

        case UPDATE_CLAIM: {
            return {
                ...state,
                claimsList: state.claimsList.map((claim) => {
                    if (claim.claimID === action.claimID) {
                        return {
                            ...claim,
                            ...action.data
                        };
                    }

                    return claim;
                })
            };
        }

        case REMOVE_PREDETERMINATION: {
            return {
                ...state,
                predeterminations: state.predeterminations.filter((item) => item.predeterminationID !== action.predeterminationID)
            };
        }

        default:
            return state;
    }
};